import React, { Component } from 'react';
import './App.css';
import settings from './config/settings.json';
import { Header } from './components/Header.js'
import { Footer } from './components/Footer.js'
import { Content } from './components/Content.js'
import { getAllUrlParams } from './helper/util.js';
import axios from 'axios';

class App extends Component {
  constructor() {
    super();

    this.state = {
      gotInfos: false,
      error: undefined,
      showHeader: false
    }
  }

  componentDidMount() {
    var apikey = getAllUrlParams().apikey;
    var url = settings.relevanz.apiBase + '/V2/user/get?apikey=' + apikey;
    if(apikey === undefined) {
      this.setState({gotInfos: true});
      this.setState({
        error: {
          id: "invalid api key",
          msg: "Ihre Authentifizierungsdaten sind nicht korrekt. Bitte überprüfen Sie diese! Sollte Sie die korrekte Daten verwenden, kontaktieren Sie bitte unseren Support!"
        }
      })
    } else {
      axios.get(url).then((result) => {
        this.setState(result.data);
        this.setState({showHeader: true});        
        this.setState({gotInfos: true});
      }).catch((error) => {
        if(error.response === undefined) {
          console.log(error);
          this.setState({
            error: {
              id: "Network error",
              msg: "Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Sollte der Fehler dauerhaft auftreten, wenden Sie sich bitte an unseren Support!"
            }
          });
        } else if(error.response.status === 401) {
          this.setState({
            error: {
              id: "invalid api key",
              msg: "Ihre Authentifizierungsdaten sind nicht korrekt. Bitte überprüfen Sie diese! Sollte Sie die korrekte Daten verwenden, kontaktieren Sie bitte unseren Support!"
            }
          })
        } else {
          this.setState({
            error: {
              id: "Undefined error",
              msg: "Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Sollte der Fehler dauerhaft auftreten, wenden Sie sich bitte an unseren Support!"
            }
          });
        }

        this.setState({gotInfos: true});
      });
    }

  }

  render() {
    return (
      <div className="page-wrapper">
      {this.state.showHeader && this.state.customerInfo.is_active && <Header gotInfos={this.state.gotInfos} error={this.state.error} />}
        <div className="page-wrapper-row full-height">
          <div className="page-wrapper-middle">
            <div className="page-container">
              <div className="page-content-wrapper">
                <div className="page-content">
                  <div className="container">
                    <div className="page-content-inner">
                      <br />
                      {!this.state.gotInfos &&
                        <div style={{width: "100%"}} className="text-center">
                          <div className="loading-message loading-message-boxed">
                            <img src="../assets/global/img/loading-spinner-grey.gif" alt=""/>
                            <span>&nbsp;&nbsp;LOADING...</span>
                          </div>
                        </div>
                      }
                      {this.state.gotInfos && this.state.customerInfo.is_active && !this.state.error && <Content
                                              customerInfo={this.state.customerInfo}
                                              stats={this.state.stats}/>}
                      {this.state.gotInfos && !this.state.customerInfo.is_active && 
                        <div>
                          <h1>Wir bedauern es, dich als Kunden verloren zu haben!</h1><br/>
                          <p>Können wir irgendwas tuen, um dich doch noch von unserem Produkt zu überzeugen? Hunderte Kunden steigern mit uns Ihren Umsatz und Gewinn. Du sollst hier auch nicht fehlen!</p>
                          <p>Gerne stehen wir dir per E-Mail (<a href="mailto:hello@releva.nz">hello@releva.nz</a>) oder telefonisch (030 863 82 564) zur Verfügung, damit wir gemeinsam eine optimale Lösung für dich und deinen Shop finden!</p>
                        </div>
                        }
                      {this.state.gotInfos && this.state.error && <b>{this.state.error.msg}</b>}
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js